import {UserAction} from '../bean/UserAction';
const globalMixin = {
    methods: {
        saveUserAction (actionPageName, actionName, type, typeValue, groupName, startTime, endTime) {
            // if(this.$route.meta.isTrial){ // 试用功能，不做用户记录
            //     return;
            // }
            startTime = startTime || moment(new Date).format('YYYY-MM-DD HH:mm:ss');
            setTimeout(() => {
                let projectId = this.$store.state.app.projectId;
                let userId = this.$store.state.app.loginUser.id;
                let userAction = new UserAction(
                    projectId,
                    startTime,
                    endTime,
                    actionPageName,
                    actionName,
                    userId ? userId : 0,
                    type, typeValue, groupName
                );
                this.webWorker.postMessage(userAction);
            }, 200)
        },
        saveUserActionForPage (projectId, startTime, endTime, pageKey, actionKey) {
            if(startTime){
                startTime = moment(new Date(startTime)).format('YYYY-MM-DD hh:mm:ss');
            }
            if(endTime){
                endTime = moment(new Date(endTime)).format('YYYY-MM-DD hh:mm:ss');
            }
            setTimeout(() => {
                let userId = this.$store.state.app.loginUser.id;
                let userAction = new UserAction(
                    projectId,
                    startTime,
                    endTime,
                    pageKey,
                    actionKey,
                    userId ? userId : 0,
                );
                if(projectId){
                    this.webWorker.postMessage(userAction);
                }
            }, 200)
        }
    }
}

export { globalMixin }